import { Navigate, Route, Routes } from "react-router-dom";
import ActivateAccountContainer from "../ui/activateAccount/activateAccountContainer";
import PublicAttendance from "../ui/appointment/attendance/publicAttendance/publicAttendance";
import ChangePasswordContainer from "../ui/changePassword/changePasswordContainer";
import PublicResponsiveFormContainer from "../ui/forms/responsiveFormContainer/publicResponsiveFormContainer/publicResponsiveFormContainer";
import LoginContainer from "../ui/login/loginContainer";
import PasswordRecoveryContainer from "../ui/passwordRecovery/passwordRecoveryContainer";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route
        path="/account/passwordRecovery"
        element={<PasswordRecoveryContainer />}
      />
      <Route
        path="/account/resetPassword"
        element={<ChangePasswordContainer />}
      />
      <Route path="/account/verify" element={<ActivateAccountContainer />} />
      <Route path="/account/login" element={<LoginContainer />} />
      <Route path="/attendance" element={<PublicAttendance />} />
      <Route path="/responsiveform/:encryptedParameters" element={<PublicResponsiveFormContainer />} />
      <Route path="*" element={<Navigate to="/account/login" />} />
    </Routes>
  );
};

export default PublicRoutes;
